/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Stream
 */
export interface Stream {
    /**
     * 
     * @type {boolean}
     * @memberof Stream
     */
    canRead?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Stream
     */
    canWrite?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Stream
     */
    canSeek?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Stream
     */
    canTimeout?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Stream
     */
    length?: number;
    /**
     * 
     * @type {number}
     * @memberof Stream
     */
    position?: number;
    /**
     * 
     * @type {number}
     * @memberof Stream
     */
    readTimeout?: number;
    /**
     * 
     * @type {number}
     * @memberof Stream
     */
    writeTimeout?: number;
}

/**
 * Check if a given object implements the Stream interface.
 */
export function instanceOfStream(value: object): value is Stream {
    return true;
}

export function StreamFromJSON(json: any): Stream {
    return StreamFromJSONTyped(json, false);
}

export function StreamFromJSONTyped(json: any, ignoreDiscriminator: boolean): Stream {
    if (json == null) {
        return json;
    }
    return {
        
        'canRead': json['canRead'] == null ? undefined : json['canRead'],
        'canWrite': json['canWrite'] == null ? undefined : json['canWrite'],
        'canSeek': json['canSeek'] == null ? undefined : json['canSeek'],
        'canTimeout': json['canTimeout'] == null ? undefined : json['canTimeout'],
        'length': json['length'] == null ? undefined : json['length'],
        'position': json['position'] == null ? undefined : json['position'],
        'readTimeout': json['readTimeout'] == null ? undefined : json['readTimeout'],
        'writeTimeout': json['writeTimeout'] == null ? undefined : json['writeTimeout'],
    };
}

export function StreamToJSON(json: any): Stream {
    return StreamToJSONTyped(json, false);
}

export function StreamToJSONTyped(value?: Stream | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'canRead': value['canRead'],
        'canWrite': value['canWrite'],
        'canSeek': value['canSeek'],
        'canTimeout': value['canTimeout'],
        'length': value['length'],
        'position': value['position'],
        'readTimeout': value['readTimeout'],
        'writeTimeout': value['writeTimeout'],
    };
}

